import * as mat4 from './glMatrix/mat4';
import * as mat3 from './glMatrix/mat3';
import * as quat from './glMatrix/quat';
import * as vec3 from './glMatrix/vec3';

const stats = {
	transforms: 0,
	worldtransforms: 0,
	transformsCheck: 0,
}

// if (settings.debug) {
// 	let $statsCanvas = document.createElement('canvas')
// 	let statsCtx = $statsCanvas.getContext('2d')
// 	$statsCanvas.width  = 150
// 	$statsCanvas.height = 50
// 	$statsCanvas.style.position = 'fixed'
// 	$statsCanvas.style.right = '300px'
// 	$statsCanvas.style.top = 0
// 	$statsCanvas.style.zIndex = 100000000
// 	$statsCanvas.style.pointerEvents = 'none'
// 	document.body.appendChild( $statsCanvas )
// 	function updateStats() {
// 		requestAnimationFrame( updateStats )
// 		statsCtx.fillStyle = '#0000ff'
// 		statsCtx.fillRect( 0, 0, $statsCanvas.width, $statsCanvas.height  )
// 		statsCtx.font = '12px sans-serif'
// 		statsCtx.textAlign = 'left'
// 		statsCtx.fillStyle = '#fff'
// 		statsCtx.fillText('transforms: '+stats.transforms, 10, 12)
// 		statsCtx.fillText('worldtransforms: '+stats.worldtransforms, 10, 12+12)
// 		statsCtx.fillText('transformsCheck: '+stats.transformsCheck, 10, 12+12+12)
// 		stats.transforms = 0;
// 		stats.transformsCheck = 0;
// 		stats.worldtransforms = 0;
// 	}
// 	updateStats()
// }


class Object3d {

	constructor() {
		
		this.position     = vec3.create();
		this.rotation     = vec3.create();
		this.scale        = vec3.create();
		this.lookAt       = null;
		
		//use to diff and only update matrix if needed
		this.lastPosition       = vec3.create();
		this.lastRotation       = vec3.create();
		this.lastScale          = vec3.create();
		this.lastLookAt         = vec3.create();

		vec3.set(this.scale, 1, 1, 1);
		this.up           = vec3.create();
		vec3.set(this.up, 0, 1, 0);
		this.matrix       = mat4.create();//modelMatrix
		this.worldMatrix  = mat4.create();//modelMatrix * parentMatri(x|ces)

		this.quaternion    = null;//quat.create();
		this._quaternion   = quat.create();

		this.inverseWorldMatrix =  mat4.create();

		this._invLookatMat4 = mat4.create();
		this._m3Rotation = mat3.create();
		this._rotationMat4 = mat4.create();
		this._lookAtMat4 = mat4.create();

		
		this._lastUpdate = Date.now()
		
		this.isFirstDraw = true;
		this._normalMatrix = mat4.create()
	}

	render(force) {
		let needsUpdate = force || this.isFirstDraw;

		if (!this.static) {

			stats.transformsCheck++

			if (this.position[0] !== this.lastPosition[0] ||
				this.position[1] !== this.lastPosition[1] ||
				this.position[2] !== this.lastPosition[2] ) {
				this.lastPosition[0] = this.position[0];
				this.lastPosition[1] = this.position[1];
				this.lastPosition[2] = this.position[2];
				needsUpdate = true;
			}
			else if (
				this.rotation[0] !== this.lastRotation[0] ||
				this.rotation[1] !== this.lastRotation[1] ||
				this.rotation[2] !== this.lastRotation[2] ) {
				this.lastRotation[0] = this.rotation[0];
				this.lastRotation[1] = this.rotation[1];
				this.lastRotation[2] = this.rotation[2];
				needsUpdate = true;
			}
			else if (
				this.scale[0] !== this.lastScale[0] ||
				this.scale[1] !== this.lastScale[1] ||
				this.scale[2] !== this.lastScale[2] ) {
				this.lastScale[0] = this.scale[0];
				this.lastScale[1] = this.scale[1];
				this.lastScale[2] = this.scale[2];
				needsUpdate = true;
			}
			else if (
				this.lookAt !== null &&
				( this.lookAt[0] !== this.lastLookAt[0] ||
				  this.lookAt[1] !== this.lastLookAt[1] ||
				  this.lookAt[2] !== this.lastLookAt[2] ) ) {
				this.lastLookAt[0] = this.lookAt[0];
				this.lastLookAt[1] = this.lookAt[1];
				this.lastLookAt[2] = this.lookAt[2];
				needsUpdate = true;
			}

		}

		//update once per frame
		//TODO: use Raf
		if (needsUpdate) {
			this.updateMatrix();
			this.updateWorldMatrix();
		}
		this.isFirstDraw = false
	}

	updateMatrix() {
		
		mat4.identity(this.matrix);
		mat4.identity(this._invLookatMat4)
		mat3.identity(this._m3Rotation)
		mat4.identity(this._rotationMat4)
		mat4.identity(this._lookAtMat4)

		if (this.quaternion) {
			mat4.fromRotationTranslation(this.matrix, this.quaternion, this.position );
			mat4.fromRotationTranslation(this._rotationMat4, this.quaternion, [0,0,0] );
		}
		else {
			mat4.translate(this.matrix, this.matrix, this.position);
			mat4.rotateY(this._rotationMat4, this._rotationMat4, this.rotation[1]);
			mat4.rotateZ(this._rotationMat4, this._rotationMat4, this.rotation[2]);
			mat4.rotateX(this._rotationMat4, this._rotationMat4, this.rotation[0]);
		}

		if (this.lookAt !== null) {
			mat4.lookAt(
				this.matrix, 
				this.position, 
				this.lookAt,
				this.up
			);
			// var _rotMat4 = mat4.create();
			// mat4.multiply(_rotMat4, _rotMat4, this._lookAtMat4);
			// mat4.getRotation( this._quaternion, _rotMat4);

			// mat4.identity(this._invLookatMat4);
			mat4.invert(this.matrix, this.matrix);
			// mat4.copy(this._rotationMat4, this._invLookatMat4);
			mat4.scale(this.matrix, this.matrix, this.scale);	
			
		}
		else {
			mat4.multiply(this.matrix, this.matrix, this._rotationMat4);
			mat4.scale(this.matrix, this.matrix, this.scale);
		}

		stats.transforms++

	}

	updateWorldMatrix() {

		if (this.parent) {
			// mat4.multiply(this.worldMatrix, this.matrix, this.parent.worldMatrix);
			mat4.multiply(this.worldMatrix, this.parent.worldMatrix, this.matrix );
		}
		else{
			mat4.copy(this.worldMatrix, this.matrix );
		}

		mat4.invert(this.inverseWorldMatrix, this.worldMatrix);

		stats.worldtransforms++


		mat4.identity( this._normalMatrix, this._normalMatrix);
		mat4.multiply( this._normalMatrix, this._normalMatrix, this._rotationMat4);
		let n = this;
		while( n.parent) {
			mat4.multiply( this._normalMatrix, this._normalMatrix, n.parent._rotationMat4);
			n = n.parent
		}

	}


}


export default Object3d;